const checkbox = {
  Checkbox: {
    baseStyle: {
      control: {
        bg: 'primary.100',
        borderRadius: 'base',
        border: '1px solid',
        borderColor: 'neutral.60',
        fontSize: '14px',
        height: "1.5rem",
        width: "1.5rem",
      }
    },
    sizes: {
      lg: {
        control: {
          w: '24px',
          h: '24px',
        },
        label: {
          fontSize: '14px'
        }
      }
    }
  }
}

export default checkbox
